import { render, staticRenderFns } from "./BannerAdvert.vue?vue&type=template&id=dd1ec778"
import script from "./BannerAdvert.vue?vue&type=script&lang=js"
export * from "./BannerAdvert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/image/Img.vue').default,Heading: require('/home/runner/work/platform/platform/packages/client/src/components/elements/typography/heading/Heading.vue').default,Button: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/button/Button.vue').default})
